import { render, staticRenderFns } from "./AliasModal.vue?vue&type=template&id=2842f8b1&scoped=true&"
import script from "./AliasModal.vue?vue&type=script&lang=js&"
export * from "./AliasModal.vue?vue&type=script&lang=js&"
import style0 from "./AliasModal.vue?vue&type=style&index=0&id=2842f8b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842f8b1",
  null
  
)

export default component.exports